var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43056 1.15278L6.69792 1.44444L6.98958 1.17708C7.79167 0.375 8.93403 0.0104165 10.0278 0.204861C11.7049 0.472222 12.9444 1.93056 12.9444 3.63194V3.75347C12.9444 4.77431 12.5069 5.74653 11.7778 6.42708L7.37847 10.5347C7.20833 10.7049 6.96528 10.7778 6.72222 10.7778C6.45486 10.7778 6.21181 10.7049 6.04167 10.5347L1.64236 6.42708C0.913194 5.74653 0.5 4.77431 0.5 3.75347V3.63194C0.5 1.93056 1.71528 0.472222 3.39236 0.204861C4.48611 0.0104165 5.62847 0.375 6.43056 1.15278C6.43056 1.17708 6.40625 1.15278 6.43056 1.15278ZM6.69792 3.09722L5.60417 1.97917C5.06944 1.46875 4.31597 1.22569 3.58681 1.34722C2.46875 1.54167 1.66667 2.48958 1.66667 3.63194V3.75347C1.66667 4.45833 1.93403 5.11458 2.44444 5.57639L6.72222 9.5625L10.9757 5.57639C11.4861 5.11458 11.7778 4.45833 11.7778 3.75347V3.63194C11.7778 2.48958 10.9514 1.54167 9.83333 1.34722C9.10417 1.22569 8.35069 1.46875 7.81597 1.97917L6.69792 3.09722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/Wishlist.a755343ac88579799b4da3ff174ddd71.svg";
export { ForwardRef as ReactComponent };